export default "__VITE_ASSET__1295682a__"